import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { 
    url: String,
    message: { type: String, default: "Are you sure you want to delete this file?" }
  }

  connect() {
    // console.log("FileDeleteController connected")
  }

  async delete(event) {
    event.preventDefault()
    
    if (!confirm(this.messageValue)) {
      return
    }
    
    this.buttonTarget.disabled = true
    
    try {
      const response = await fetch(`${this.urlValue}.json`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      })
      
      if (response.ok) {
        window.location.href = window.location.pathname
      } else {
        console.error('Error deleting file:', response.statusText)
        alert('There was an error deleting the file.')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('There was an error processing your request.')
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
